(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-iona-cart-page]');
  if (!root) return;

  const moneyFormatString = root.dataset.moneyFormat || '${{amount}}';
  function moneyFormat(cents) {
    return (cents / 100).toFixed(2);
  }

  // Qty steppers
  root.querySelectorAll('[data-cart-line]').forEach((line) => {
    const key = line.dataset.lineKey;
    const qty = line.querySelector('[data-line-qty]');
    line.querySelector('[data-line-decr]').addEventListener('click', () => updateLine(key, Math.max(0, parseInt(qty.value, 10) - 1), line));
    line.querySelector('[data-line-incr]').addEventListener('click', () => updateLine(key, parseInt(qty.value, 10) + 1, line));
    qty.addEventListener('change', () => updateLine(key, Math.max(0, parseInt(qty.value, 10) || 0), line));
    const rm = line.querySelector('[data-line-remove]');
    if (rm) rm.addEventListener('click', (e) => { e.preventDefault(); updateLine(key, 0, line); });
  });

  async function updateLine(key, quantity, line) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) return;
      const cart = await res.json();
      if (quantity === 0) {
        line.remove();
      } else {
        const item = cart.items.find((i) => i.key === key);
        if (item) {
          line.querySelector('[data-line-qty]').value = item.quantity;
          line.querySelector('[data-line-price]').textContent = '₹' + moneyFormat(item.final_line_price);
        }
      }
      const sub = root.querySelector('[data-cart-subtotal]');
      const tot = root.querySelector('[data-cart-total]');
      if (sub) sub.textContent = '₹' + moneyFormat(cart.items_subtotal_price);
      if (tot) tot.textContent = '₹' + moneyFormat(cart.total_price);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
      if (cart.item_count === 0) window.location.reload();
    } catch (e) {}
  }

  // Gift toggle UI
  const giftToggle = root.querySelector('[data-gift-toggle]');
  const giftMsg = root.querySelector('[data-gift-msg]');
  const giftCheck = root.querySelector('[data-gift-check]');
  if (giftToggle) {
    giftToggle.addEventListener('change', async () => {
      giftMsg.classList.toggle('hidden', !giftToggle.checked);
      giftCheck.textContent = giftToggle.checked ? '✓' : '';
      const fd = new FormData();
      fd.append('attributes[Gift wrap]', giftToggle.checked ? 'Yes' : '');
      try { await fetch('/cart/update.js', { method: 'POST', body: fd }); } catch (e) {}
    });
  }
  if (giftMsg) {
    let t;
    giftMsg.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const fd = new FormData();
        fd.append('attributes[Gift message]', giftMsg.value);
        try { await fetch('/cart/update.js', { method: 'POST', body: fd }); } catch (e) {}
      }, 500);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-iona-collection]');
  if (!root) return;

  // Dropdowns
  root.querySelectorAll('[data-dropdown]').forEach((dd) => {
    const btn = dd.querySelector('[data-dropdown-toggle]');
    const panel = dd.querySelector('[data-dropdown-panel]');
    const icon = dd.querySelector('[data-dropdown-icon]');
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !panel.classList.contains('hidden');
      root.querySelectorAll('[data-dropdown-panel]').forEach((p) => p.classList.add('hidden'));
      root.querySelectorAll('[data-dropdown-icon]').forEach((i) => i.classList.remove('rotate-180'));
      if (!open) {
        panel.classList.remove('hidden');
        icon && icon.classList.add('rotate-180');
      }
    });
    panel.addEventListener('click', (e) => e.stopPropagation());
    panel.addEventListener('mousedown', (e) => e.stopPropagation());
  });
  document.addEventListener('click', () => {
    root.querySelectorAll('[data-dropdown-panel]').forEach((p) => p.classList.add('hidden'));
    root.querySelectorAll('[data-dropdown-icon]').forEach((i) => i.classList.remove('rotate-180'));
  });

  // Column toggle
  const grid = root.querySelector('[data-products-grid]');
  const toggle = root.querySelector('[data-cols-toggle]');
  if (grid && toggle) {
    const stored = localStorage.getItem('iona:cols') || '4';
    setCols(stored);
    toggle.querySelectorAll('[data-cols]').forEach((b) => {
      b.addEventListener('click', () => { setCols(b.dataset.cols); localStorage.setItem('iona:cols', b.dataset.cols); });
    });
    function setCols(c) {
      grid.classList.remove('cols-2', 'cols-3', 'cols-4', 'md:grid-cols-2', 'md:grid-cols-3', 'md:grid-cols-4');
      grid.classList.add('cols-' + c);
      toggle.querySelectorAll('[data-cols]').forEach((b) => {
        const on = b.dataset.cols === c;
        b.classList.toggle('text-iona-bg', on);
        b.classList.toggle('text-[#aaa8a4]', !on);
      });
    }
  }

})();

// Collection card carousel — kept independent so it initialises
// regardless of anything else on the page.
(function () {
  const carousel = document.querySelector('[data-collection-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('[data-cc-track]');
  const cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-cc-card]'));
  const prev = carousel.querySelector('[data-cc-prev]');
  const next = carousel.querySelector('[data-cc-next]');
  if (!track || !cards.length) return;

  // Scroll roughly one "page" of cards per arrow click.
  const step = () => {
    const gap = parseFloat(getComputedStyle(track).columnGap) || 24;
    const cardW = cards[0].offsetWidth + gap;
    const per = Math.max(1, Math.floor(track.clientWidth / cardW));
    return cardW * per;
  };

  const updateArrows = () => {
    // 2px tolerance for sub-pixel scroll positions.
    const maxScroll = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maxScroll;
  };

  if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

  let raf;
  track.addEventListener('scroll', () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(updateArrows);
  }, { passive: true });
  window.addEventListener('resize', updateArrows);

  // Always begin at the very start, then re-check once images/layout settle.
  const start = () => {
    track.scrollLeft = 0;
    updateArrows();
  };
  start();
  requestAnimationFrame(start);
  window.addEventListener('load', updateArrows);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function(){
    const nav = document.querySelector('[data-iona-nav]');
    if(!nav) return;
    let scrolled = false;
    window.addEventListener('scroll', () => {
      const s = window.scrollY > 20;
      if(s !== scrolled){ scrolled = s; nav.classList.toggle('is-scrolled', s); }
    });

    const mobToggle = document.querySelector('[data-iona-mobile-toggle]');
    const mobMenu = document.querySelector('[data-iona-mobile-menu]');
    const iMenu = document.querySelector('[data-icon-menu]');
    const iClose = document.querySelector('[data-icon-close]');
    if(mobToggle && mobMenu){
      mobToggle.addEventListener('click', () => {
        const open = mobMenu.classList.toggle('is-open');
        iMenu && iMenu.classList.toggle('hidden', open);
        iClose && iClose.classList.toggle('hidden', !open);
      });
    }

    const megaTriggers = document.querySelectorAll('[data-iona-mega-trigger]');
    const megaPanels = document.querySelectorAll('[data-iona-mega]');
    let megaTimer;
    const openMega = (id) => {
      clearTimeout(megaTimer);
      megaTriggers.forEach(t => t.classList.toggle('is-active', t.dataset.ionaMegaTrigger === id));
      megaPanels.forEach(p => p.hidden = p.dataset.ionaMega !== id);
    };
    const closeMega = () => {
      megaTimer = setTimeout(() => {
        megaTriggers.forEach(t => t.classList.remove('is-active'));
        megaPanels.forEach(p => p.hidden = true);
      }, 120);
    };
    megaTriggers.forEach(t => {
      t.addEventListener('mouseenter', () => openMega(t.dataset.ionaMegaTrigger));
      t.addEventListener('mouseleave', closeMega);
    });
    megaPanels.forEach(p => {
      p.addEventListener('mouseenter', () => clearTimeout(megaTimer));
      p.addEventListener('mouseleave', closeMega);
    });

    const searchOverlay = document.querySelector('[data-iona-search-overlay]');
    document.querySelectorAll('[data-iona-search-open]').forEach(b => b.addEventListener('click', () => searchOverlay.classList.add('is-open')));
    const closeBtn = document.querySelector('[data-iona-search-close]');
    if(closeBtn) closeBtn.addEventListener('click', () => searchOverlay.classList.remove('is-open'));
    searchOverlay.addEventListener('click', (e) => { if(e.target === searchOverlay) searchOverlay.classList.remove('is-open'); });

    document.addEventListener('cart:updated', (e) => {
      const count = e.detail && e.detail.item_count;
      const el = document.querySelector('[data-iona-cart-count]');
      if(el && typeof count === 'number'){ el.textContent = count; el.classList.toggle('hidden', count === 0); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-iona-product]');
  if (!root) return;

  // Gallery
  const slides = root.querySelectorAll('[data-gallery-slide]');
  const thumbs = root.querySelectorAll('[data-gallery-thumb]');
  const prev = root.querySelector('[data-gallery-prev]');
  const next = root.querySelector('[data-gallery-next]');
  const stage = root.querySelector('[data-gallery-stage]');
  let active = 0;

  function scrollToStage() {
    if (!stage) return;
    const top = stage.getBoundingClientRect().top + window.pageYOffset - 90; // clear sticky header
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function show(i) {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    slides.forEach((el, idx) => {
      const on = idx === i;
      el.classList.toggle('opacity-100', on);
      el.classList.toggle('opacity-0', !on);
      el.classList.toggle('pointer-events-none', !on);

      const v = el.querySelector('video');
      if (v) {
        if (on) {
          v.muted = true;
          v.play().catch(() => {}); // autoplay requires muted; ignore rejection
        } else if (!v.paused) {
          v.pause();
        }
      }

      const iframe = el.querySelector('[data-gallery-iframe]');
      if (iframe) {
        const target = on ? iframe.dataset.srcActive : iframe.dataset.srcIdle;
        if (target && iframe.getAttribute('src') !== target) iframe.setAttribute('src', target);
      }
    });
    thumbs.forEach((t, idx) => {
      const on = idx === i;
      t.classList.toggle('border-iona-bg', on);
      t.classList.toggle('border-transparent', !on);
    });
    active = i;
  }
  thumbs.forEach((t) => t.addEventListener('click', () => { show(parseInt(t.dataset.index, 10)); scrollToStage(); }));
  if (prev) prev.addEventListener('click', () => show(active - 1));
  if (next) next.addEventListener('click', () => show(active + 1));

  // Quantity
  const qty = root.querySelector('[data-qty-input]');
  const dec = root.querySelector('[data-qty-decr]');
  const inc = root.querySelector('[data-qty-incr]');
  if (dec) dec.addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1); });
  if (inc) inc.addEventListener('click', () => { qty.value = parseInt(qty.value || '1', 10) + 1; });

  // Variants
  const select = root.querySelector('[data-variant-select]');
  const optionBtns = root.querySelectorAll('[data-option-value]');
  const priceEl = root.querySelector('[data-product-price]');
  const compareEl = root.querySelector('[data-product-compare]');
  const cta = root.querySelector('[data-add-to-cart]');
  const ctaLabel = root.querySelector('[data-cta-label]');

  const selected = {};
  root.querySelectorAll('[data-option-group]').forEach((group) => {
    const pos = group.dataset.optionPosition;
    const cur = group.querySelector('.bg-iona-bg');
    if (cur) selected[pos] = cur.dataset.optionValue;
  });

  function updateVariant() {
    let match = null;
    Array.from(select.options).forEach((opt) => {
      const o1 = opt.dataset.option1;
      const o2 = opt.dataset.option2;
      const o3 = opt.dataset.option3;
      if (
        (!selected['1'] || selected['1'] === o1) &&
        (!selected['2'] || selected['2'] === o2) &&
        (!selected['3'] || selected['3'] === o3)
      ) {
        if (!match) match = opt;
      }
    });
    if (!match) return;
    select.value = match.value;
    if (priceEl) priceEl.textContent = match.dataset.price;
    if (compareEl && match.dataset.compare && match.dataset.compare !== '') {
      compareEl.textContent = match.dataset.compare;
    }
    const available = match.dataset.available === 'true';
    if (cta) cta.disabled = !available;
    if (ctaLabel) ctaLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
  }

  optionBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const pos = btn.dataset.optionPosition;
      selected[pos] = btn.dataset.optionValue;
      root.querySelectorAll('[data-option-position="' + pos + '"]').forEach((sib) => {
        sib.classList.remove('bg-iona-bg', 'text-white', 'border-iona-bg');
        sib.classList.add('border-[rgba(0,0,0,0.2)]', 'text-iona-bg');
      });
      btn.classList.remove('border-[rgba(0,0,0,0.2)]', 'text-iona-bg');
      btn.classList.add('bg-iona-bg', 'text-white', 'border-iona-bg');
      updateVariant();
    });
  });

  // Accordion
  root.querySelectorAll('[data-accordion-item]').forEach((item) => {
    const trig = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    const icon = item.querySelector('[data-accordion-icon]');
    trig.addEventListener('click', () => {
      const open = !panel.classList.contains('hidden');
      panel.classList.toggle('hidden', open);
      if (icon) icon.classList.toggle('rotate-180', !open);
    });
  });

  // Async add-to-cart for cart drawer integration (graceful fallback to normal submit if fetch fails)
  const form = root.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      cta.disabled = true;
      const original = ctaLabel.textContent;
      ctaLabel.textContent = 'Adding...';
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        ctaLabel.textContent = 'Added to Cart';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => { ctaLabel.textContent = original; cta.disabled = false; }, 1200);
      } catch (err) {
        ctaLabel.textContent = 'Error';
        setTimeout(() => { ctaLabel.textContent = original; cta.disabled = false; }, 1500);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
